export default "__VITE_ASSET__C7oZ6nuk__"